import { computed, defineComponent, onMounted } from '@vue/runtime-core';
export default defineComponent({
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props) {
    return {
      iconName: computed(function () {
        return "#icon-".concat(props.iconClass);
      }),
      svgClass: computed(function () {
        if (props.className) {
          return "svg-icon ".concat(props.className);
        }

        return 'svg-icon';
      })
    };
  }
});